module.exports = __webpack_public_path__ + "Tail_feathers_Normal.0963b9d.basis";